<template>
  <form @submit.prevent="submit">
    <div class="row">
      <w-input class="form-group col-12" type="password" :model="$schema.currentPassword" />

      <w-input class="form-group col-12" type="password" :model="$schema.password" />

      <w-input class="form-group col-12" type="password" :model="$schema.repeat" />

      <div class="col-12">
        <button v-if="showCancelButton" type="button" class="btn btn-secondary float-left" @click="$emit('cancel')">
          {{ cancelButtonText }}
        </button>

        <button type="submit" class="btn btn-danger float-right">
          {{ buttonText }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/password.schema';

// @vuese
// Formularz haseł
// @group Forms
export default {
  name: 'PasswordForm',
  mixins: [formMixin, notificationsMixin],
  props: {
    // Tekst przycisku
    buttonText: {
      type: String,
      required: false,
      default: 'Zapisz'
    },
    // Czy pytać o obecne hasło
    withCurrentPassword: {
      type: Boolean,
      required: false,
      default: false
    },

    // Czy pokazać przycisk do anulowania
    showCancelButton: {
      type: Boolean,
      required: false,
      default: false
    },

    // Tekst przycisku anulowania
    cancelButtonText: {
      type: String,
      required: false,
      default: 'Anuluj'
    }
  },
  data() {
    return {
      model: {
        password: '',
        repeat: ''
      }
    };
  },
  schema,
  created() {
    if (this.withCurrentPassword) {
      this.$schema.currentPasswordRequired.$setData(this.withCurrentPassword);
    }
  },
  methods: {
    // @vuese
    // Ustawia wpisane hasło
    submit() {
      if (!this.$schema.$validateAll().length) {
        this.$emit(
          'setPassword',
          this.withCurrentPassword
            ? { currentPassword: this.model.currentPassword, password: this.model.password }
            : this.model.password
        );
      }
    }
  }
};
</script>
